import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { MainLayoutService } from 'src/app/layout/services/main-layout.service';

@Component({
  selector: 'app-vis-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class VisButtonComponent implements OnInit {

  @Input()
  title: string = null;
  @Input()
  icon: string;
  @Input()
  animateIcon: boolean = false;
  @Input()
  animateBtn: boolean = false;
  @Input()
  label: string;
  @Input()
  disabled: boolean = false;
  @Input()
  disabledByLoader: boolean = true;
  @Input()

  styleType: 'primary' | 'warning' | 'secondary' | 'none' = 'none';


  @Input()
  btnCls: string = '';
  @Input()
  iconCls: string = '';
  @Input()
  type: 'submit' | 'button' = 'button'
  @Input()
  fontSize: 'm' | 's' | 'xs' | 'l' = 'm'
  get _btnCls(): string {
    return this.btnCls + (this.styleType == 'primary' ? ' primary' : '') + (this.animateBtn ? ' btn-animate' : '');
  }
  get _iconCls(): string {
    return this.iconCls + (this.styleType == 'warning' ? ' remove' : '') + (this.animateIcon ? ' icon-animate' : '');
  }
  get _spanCls(): string {
    return this.fontSize == 'l' ? 'controlled-font-size-large' :
      this.fontSize == 's' ? 'controlled-font-size-small' :
        this.fontSize == 'xs' ? 'controlled-font-size-xs' : 'controlled-font-size-middle'
  }
  @Output()
  click: EventEmitter<Event> = new EventEmitter();
  constructor(private ele: ElementRef<HTMLElement>,
    private mainLayoutService: MainLayoutService,
  ) {
    this.ele.nativeElement.style.display = 'inline-block'
  }
  isClicking = false;
  loading$ = this.mainLayoutService.isShowLoader$;

  ngOnInit(): void {
    if (this.title == null) {
      this.title = this.label;
    }
  }
  onClick(evt: Event) {
    if (this.isClicking) return;
    this.isClicking = true;
    evt.stopPropagation();
    this.click.emit(evt);
    setTimeout(() => {
      this.isClicking = false;
    }, 1000);
  }
}
